import './isin-rating-form.scss'

import { notification } from 'antd'
import axios from 'axios'
import { Formik } from 'formik'
import { DatePicker, Form, FormItem, Input, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column } from 'react-display-flex'

import { SelectRating } from '../../../components/SelectRating'
import { isinRatingFormInitialValues, IsinRatingFormValues } from '../models'
import { isinMessages } from './messages'
import { isinRatingValidationSchema } from './validators'

export const UpdateIsinRating = ({ isin, onSuccess }: { isin: string; onSuccess: () => void }) => {
  const onSubmit = async ({ startDate, short, long }: IsinRatingFormValues) => {
    const data = [{ securityId: isin, startDate, rating: { short, long } }]

    try {
      await axios.post('/isins/ratings', data)
      notification.success({
        message: isinMessages.common.success,
        description: isinMessages.isinRating.update.success,
      })
      onSuccess()
    } catch (error) {
      notification.error({ message: isinMessages.common.error, description: isinMessages.isinRating.update.error })
    }
  }

  return (
    <Formik
      initialValues={isinRatingFormInitialValues}
      validationSchema={isinRatingValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="update-isin-rating">
        <FormItem label="ISIN" name="isin">
          <Input name="isin" value={isin} disabled />
        </FormItem>
        <FormItem name="startDate" label="Start Date" required>
          <DatePicker name="startDate" />
        </FormItem>
        <FormItem name="short" label="Short Rating" required>
          <SelectRating name="short" />
        </FormItem>
        <FormItem name="long" label="Long Rating" required>
          <SelectRating name="long" longRatings />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
